import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CourtService } from '@shared/services/court.service';
import { map } from 'rxjs';
import { MultipleApplicationsHttpService } from '@shared/features/multiple-applications/services/multiple-apps-http.service';

export const multipleApplicationsGuard: CanActivateFn = () => {
  const courtService = inject(CourtService);

  const multipleAppsHttp = inject(MultipleApplicationsHttpService);

  return multipleAppsHttp
    .getApplications(Number(courtService.courtId()))
    .pipe(map((response) => response.count > 0));
};
